module.exports = __webpack_public_path__ + "assets/img/footer_logo_2.cfefb234.png";